import { Injectable } from '@angular/core';
import { Subscription, BehaviorSubject, combineLatest } from 'rxjs';
import { DataSourceService } from './data-source.service';
import * as moment from 'moment';
import { Loan, LoanListItem } from '@akiba/models_bimbo';
import { take } from 'rxjs/operators';
import { Helpers } from '../models/helpers';

@Injectable()
export class PendingLoanRequestLogicService {

  employeeObjArray = Array<any>();

  pendingLoansSubscription: Subscription;
  deniedLoansSubscription: Subscription;

  pendingListCount = 0;
  approvedPendingListCount = 0;

  approvedPendingList: Array<LoanListItem> = Array<LoanListItem>();

  pendingList: Array<LoanListItem> = Array<LoanListItem>();
  deniedList: Array<LoanListItem> = Array<LoanListItem>();

  pendingListCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  deniedListCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  approvedPendingListCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  pendingListSubject: BehaviorSubject<Array<LoanListItem>> = new BehaviorSubject<Array<LoanListItem>>(new Array<LoanListItem>());
  deniedListSubject: BehaviorSubject<Array<LoanListItem>> = new BehaviorSubject<Array<LoanListItem>>(new Array<LoanListItem>());
  approvedPendingListSubject: BehaviorSubject<Array<LoanListItem>> = new BehaviorSubject<Array<LoanListItem>>(new Array<LoanListItem>());

  constructor(private dataSource: DataSourceService) {
  }

  async loadPendingLoans(uid: string) {

    this.pendingLoansSubscription = this.dataSource.loadSupervisorPendingLoans(uid).subscribe(queryResults => {

      this.pendingList = Array<LoanListItem>();

      for (const q of queryResults) {

        if (q.type === "added") {
          this.pendingList[q.payload.newIndex] = new LoanListItem(q.payload.doc.data());
        }
        if (q.type === "modified") {
          this.pendingList[q.payload.oldIndex] = new LoanListItem(q.payload.doc.data());
        }
        if (q.type === "removed") {
          this.pendingList.splice(q.payload.oldIndex, 1);
        }

      }

      this.pendingListCount = this.pendingList.length;
      this.pendingListSubject.next(this.pendingList);
      this.pendingListCountSubject.next(this.pendingListCount);

    })


  }

  async loadAllPendingLoans() {

    this.pendingLoansSubscription = this.dataSource.loadAllPendingLoans().subscribe(queryResults => {

      this.pendingList = Array<LoanListItem>();

      for (const q of queryResults) {

        if (q.type === "added") {
          this.pendingList[q.payload.newIndex] = new LoanListItem(q.payload.doc.data());
        }
        if (q.type === "modified") {
          this.pendingList[q.payload.oldIndex] = new LoanListItem(q.payload.doc.data());
        }
        if (q.type === "removed") {
          this.pendingList.splice(q.payload.oldIndex, 1);
        }

      }

      this.pendingListCount = this.pendingList.length;
      this.pendingListSubject.next(this.pendingList);
      this.pendingListCountSubject.next(this.pendingListCount);

    });

  }

  async loadAllApprovedPendingLoans() {

    this.dataSource.callbackApprovedPendingWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {

        if (!doc) {
          continue;
        }

        this.approvedPendingList.push(new LoanListItem(doc));

      }

      this.approvedPendingListSubject.next(this.approvedPendingList);

      return true;

    };

    this.approvedPendingList = Array<LoanListItem>();

    await this.dataSource.activePendingLoans(100, 500);
    return;

  }

  async loadDeniedLoans(uid: string) {

    this.deniedList = Array<LoanListItem>();
    this.dataSource.loadWorkFlowFor(uid).pipe(take(1)).toPromise().then((workflow: any) => {
      const aDate = moment();
      aDate.add(-9, 'days');

      if (workflow.supervising) {
        const map = workflow.supervising.map(element => this.dataSource.loadDeniedLoans(element, aDate.toDate()));
        const all = combineLatest([map]);

        if (this.deniedLoansSubscription) {
          this.deniedLoansSubscription.unsubscribe();
          this.deniedLoansSubscription = null;
        }

        this.deniedLoansSubscription = all.subscribe((result: any) => {
          const flat = result.reduce(((prev, next) => next ? prev.concat(next) : prev), []).map(element => new LoanListItem(element));
          
          this.deniedList = flat;
          this.deniedListCountSubject.next(this.deniedList.length);
        });

      }

    });

  }

  async loadAllLastDeniedLoans() {

    this.deniedList = Array<LoanListItem>();
    const aDate = moment();
    aDate.add(-9, 'days');

    this.dataSource.loadAdministratorDeniedLoans(aDate.toDate()).subscribe(result => {
      const flat = result.reduce(((prev, next) => next ? prev.concat(next) : prev), []).map(element => new LoanListItem(element));
      this.deniedList = flat;
      this.deniedListCountSubject.next(this.pendingList.length);
    });

  }

  stopAllListeners() {

    if (this.pendingLoansSubscription && !this.pendingLoansSubscription.closed) {
      this.pendingLoansSubscription.unsubscribe();
      this.pendingLoansSubscription = null;
    }

    if (this.deniedLoansSubscription && !this.deniedLoansSubscription.closed) {
      this.deniedLoansSubscription.unsubscribe();
      this.deniedLoansSubscription = null;
    }

    this.pendingList.splice(0, this.pendingList.length);
    this.deniedList.splice(0, this.deniedList.length);
    this.approvedPendingList.splice(0, this.approvedPendingList.length);

    this.pendingListCountSubject.next(0);
    this.deniedListCountSubject.next(0);
    this.approvedPendingListCountSubject.next(0);


  }

}
